import { useEffect } from "react";
import { useStore } from "../../../contexts/store-provider";
import { observer } from "mobx-react";
import { ISaleRecordList } from "../../../models/response/ISMRResponse";
import AddEditSaleRecord from "./add-edit-sale-record";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import { getHeadquarterIdFromLocalStorage, getUserTypeFromLocalStorage } from "../../../helpers/localstorage-helper";
import { SMRTabEnum } from "../../../constants/enums/smr-tab-enum";
import Nodata from "../../../shared-components/no-data-svg/no-data-svg";
import { FormattedMessage } from "react-intl";
import NoSale from "../../../shared-components/no-data-svg/no-sale-svg";
import userTypeEnum from "../../../constants/enums/user-type-enum";

interface IProps {
  customerId: number;
  storeId: number;
  viewOnly: boolean;
  shouldPreventScroll?: React.MutableRefObject<boolean>;
}

const SalesRecord = (props: IProps) => {
  const { customerId, storeId, viewOnly } = props;
  const { smrStore, masterManagementStore, customerManagementStore } =
    useStore();
  const { GetCustomerByIdService } = customerManagementStore;
  const {
    GetSaleRecordListByBookingIdService,
    allSalesRecord,
    selectedBookingId,
    addUpdateSaleRecordState,
    resetAddUpdateSaleRecordState,
    setRegisterSale,
    registerSale,
    GetBookingListByCustomerIdService,
    addUpdatePaymentDetailsBySaleRecordIdState,
    resetAddUpdatePaymentDetailsBySaleRecordIdState,
    salesRecordState,
    bookingListState,
    deleteSaleRecordState,
    deleteSMRState,
    refundSaleRecordState,
    resetRefundSaleRecordState,
    selectedSaleRecrodForCreatingNewSale,
    setSelectedSaleRecrodForCreatingNewSale,
    activeTab,
    resetDeleteSaleRecordState,
    resetSalesRecordListState,
    setOpenAccountingPopupSaleRecordId
  } = smrStore;
  const {
    GetAllStaffOptionServiceByStoreId,
    getAllStaffOptions,
    staffOptionsState,
    GetConsumptionTaxByHeadquarterIdService,
    getByIdConsumptionTaxState,
  } = masterManagementStore;

  const headquarterIdFromLocalStorage = getHeadquarterIdFromLocalStorage();

  useEffect(() => {
    if (activeTab !== SMRTabEnum.Sales) return;
    const isStoreUser = userTypeEnum[userTypeEnum.Store] === getUserTypeFromLocalStorage();
    if (!isStoreUser || props.storeId > 0)
      GetAllStaffOptionServiceByStoreId(props.storeId);
    if (headquarterIdFromLocalStorage > 0)
      GetConsumptionTaxByHeadquarterIdService(headquarterIdFromLocalStorage);
  }, [activeTab]);

  useEffect(() => {
   return(()=>{
    resetSalesRecordListState();
    setOpenAccountingPopupSaleRecordId(-1);
   })
  }, []);

  // useEffect(()=>{
  //   if(activeTab == SMRTabEnum.Sales && allBookingList?.length > 0 && selectedAppointmentIdForPayment > 0){
  //     const smrId = allBookingList.filter((record) => record.AppointmentId === selectedAppointmentIdForPayment)[0]?.Id || -1;
  //     if(smrId > 0)
  //       setSelectedBookingId(smrId);
  //   }
  // },[activeTab, allBookingList]);

  useEffect(() => {
    if (activeTab == SMRTabEnum.Sales && selectedBookingId > 0) {
      resetSalesRecordListState();
      GetSaleRecordListByBookingIdService(selectedBookingId);
    }
  }, [selectedBookingId, activeTab]);

  useEffect(() => {
    if (addUpdateSaleRecordState.success) {
      if (selectedBookingId > 0) {  
        if (registerSale) {
          toast.success(formatMessage("added_success"));
          // GetBookingListByCustomerIdService(customerId, storeId);
          setRegisterSale(false);
        }
        else if (selectedSaleRecrodForCreatingNewSale > 0) {
          toast.success(formatMessage("new_item_added_success"));
          GetSaleRecordListByBookingIdService(selectedBookingId);
          setSelectedSaleRecrodForCreatingNewSale(-1);
        } else {
          GetSaleRecordListByBookingIdService(selectedBookingId);
          toast.success(formatMessage("updated_success"));
        }
      }
      GetBookingListByCustomerIdService(customerId, storeId);
      
    }
  }, [addUpdateSaleRecordState.success]);

  useEffect(() => {
    if (addUpdatePaymentDetailsBySaleRecordIdState.success) {
      GetSaleRecordListByBookingIdService(selectedBookingId);
      let userTypeFromLocalStorage = getUserTypeFromLocalStorage();
      GetCustomerByIdService(customerId,
        (userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.SuperAdmin] && userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.HeadQuarter])
          ? storeId
          : null);
      resetAddUpdatePaymentDetailsBySaleRecordIdState();
    }
  }, [addUpdatePaymentDetailsBySaleRecordIdState.success]);

  useEffect(() => {
    if (deleteSaleRecordState.success) {
      toast.success(formatMessage("deleted_success"));
      GetSaleRecordListByBookingIdService(selectedBookingId);
      GetBookingListByCustomerIdService(customerId, storeId);
      resetDeleteSaleRecordState();
    }
  }, [deleteSaleRecordState.success]);

  useEffect(() => {
    if (refundSaleRecordState.success) {
      GetSaleRecordListByBookingIdService(selectedBookingId);
      GetBookingListByCustomerIdService(customerId, storeId);
      resetRefundSaleRecordState();
    }
  }, [refundSaleRecordState.success]);

  return (
    <>
      {!registerSale ? (
        <>
          {(bookingListState.inProgress ||
            getByIdConsumptionTaxState.inProgress ||
            staffOptionsState.inProgress ||
            salesRecordState.inProgress ||
            addUpdateSaleRecordState.inProgress ||
            deleteSaleRecordState.inProgress ||
            deleteSMRState.inProgress ||
            refundSaleRecordState.inProgress) && (
            <FormLoader
              loading={
                getByIdConsumptionTaxState.inProgress ||
                bookingListState.inProgress ||
                staffOptionsState.inProgress ||
                salesRecordState.inProgress ||
                addUpdateSaleRecordState.inProgress ||
                deleteSMRState.inProgress ||
                deleteSaleRecordState.inProgress ||
                refundSaleRecordState.inProgress
              }
            />
          )}
          {allSalesRecord?.length > 0 ? (
            allSalesRecord.map((saleRecord: ISaleRecordList) => {
              return (
                <>
                  <AddEditSaleRecord
                    smrId={saleRecord.SMRId}
                    saleRecordItem={saleRecord}
                    customerId={customerId}
                    storeId={storeId}
                    getAllStaffOptions={getAllStaffOptions}
                    isDisabled={
                      viewOnly
                        ? viewOnly
                        : saleRecord.SaleRecordPaymentStatus ||
                          !saleRecord.IsActiveRecord
                    }
                    viewOnly={viewOnly}
                  />
                </>
              );
            })
          ) : (
            <div className="text-danger text-center no-data">
              <NoSale />
              <p className="text-danger">
                <strong>
                  <FormattedMessage id="no_data_available" />
                </strong>
              </p>
            </div>
          )}
        </>
      ) : (
        <AddEditSaleRecord
          smrId={-1}
          customerId={customerId}
          storeId={storeId}
          saleRecordItem={undefined}
          getAllStaffOptions={getAllStaffOptions}
          isDisabled={viewOnly ? viewOnly : false}
          shouldPreventScroll={props.shouldPreventScroll}
          viewOnly={viewOnly}
        />
      )}
    </>
  );
};

export default observer(SalesRecord);
